/**
 * Cookie の値を取得します。
 *
 * @param {string} key - 取得するCookieのキー
 * @returns {string} 指定したキーのCookieの値。該当するキーがない場合は空文字を返します。
 */
export function getCookie(key) {
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
        const [cookieKey, cookieValue] = cookie.trim().split('=');
        if (cookieKey === encodeURIComponent(key)) {
            return decodeURIComponent(cookieValue);
        }
    }

    return '';
}
